import { JSX } from "react";
import { Navigate } from "react-router-dom";
import { useSession } from "../authentication/SessionHooks";

type AuthGuardProps = {
  children: JSX.Element;
  canAccess?: () => boolean;
}

export function AuthGuard(props: AuthGuardProps): JSX.Element | null {
  const { initialized, session } = useSession();

  if (initialized === false)
    return null;

  if (session.authenticated === false)
    return <Navigate to="/login" />;

  if (props.canAccess && !props.canAccess())
    return <Navigate to="/forbidden" />;

  return props.children;
}
